import LabServiceModel from "@/models/LabServiceModel";
import ScheduleModel from "./ScheduleModel";
import ScheduleStatusModel from "./ScheduleStatusModel";

export default class ScheduleStatusLogModel extends LabServiceModel {
  modelName() {
    return 'schedule-status-log';
  }
  defaults() {
    return {
      id: null,
      schedule_id: null,
      schedule: null,
      schedule_status_id: null,
      schedule_status: null,
      start_date: null,
      end_date: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      schedule_id: (val) => (this.nullStringMutator(val)),
      schedule_status_id: (val) => (this.nullStringMutator(val)),
      start_date: (val) => (this.nullStringMutator(val)),
      end_date: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getSchedule() {
    return this.getRelatedModel(ScheduleModel, 'schedule');
  }
  getScheduleStatus() {
    return this.getRelatedModel(ScheduleStatusModel, 'schedule_status');
  }
  getStatus() {
    return this.getScheduleStatus();
  }
}
